import Hook from "../utils/hook"

export default Hook(`CardsCarousel`, {
  refs: [`carousel`],
  targets: [`navPrev`, `navNext`],
  actions: [
    {
      target: `navPrev`,
      name: `scrollPrev`,
      type: `click`,
    },
    {
      target: `navNext`,
      name: `scrollNext`,
      type: `click`,
    },
    {
      name: `keyNavigate`,
      type: `keydown`,
    },
  ],

  carouselRefMounted(carouselRef) {
    carouselRef.addScrollEndHandler(this.scrollEnded.bind(this))
    this.scrollEnded()
  },

  scrollNextAction() {
    if (this.carouselRef) this.carouselRef.scrollNext()
  },

  scrollPrevAction() {
    if (this.carouselRef) this.carouselRef.scrollPrev()
  },

  // ← / → for the focus in the header (e.g. on the prev / next buttons); the
  // carousel itself handles them for the focus on its items
  keyNavigateAction(e) {
    if (!this.carouselRef || this.carouselRef.el.contains(e.target)) return

    this.carouselRef.keyNavigate(e)
  },

  scrollEnded() {
    if (!this.carouselRef) return

    if (this.navPrevTarget)
      this.navPrevTarget.disabled = this.carouselRef.isBeginning()

    if (this.navNextTarget)
      this.navNextTarget.disabled = this.carouselRef.isEnd()
  },
})
